import React from 'react';
type EyebrowProps = {
  children: React.ReactNode;
  className?: string;
};
export function Eyebrow({
  children,
  className = ''
}: EyebrowProps) {
  return <p className={`font-sans text-[10px] font-bold uppercase tracking-[0.28em] text-brand ${className}`} data-id="element-45" data-mp="1pp3u2m0z8peb">
      {children}
    </p>;
}